import React from 'react';
import { Box, TextField, Button, Stack } from '@mui/material';

const CustomersFilters = ({ search, createdFrom, createdTo, onChange, onClear }) => {
    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            alignItems={{ xs: 'stretch', sm: 'center' }}
        >
            <TextField
                size="small"
                placeholder="Search username or email"
                value={search}
                onChange={(e) => onChange({ search: e.target.value })}
                sx={{ minWidth: { sm: 260 }, flex: 1 }}
            />
            <TextField
                size="small"
                type="date"
                label="From"
                InputLabelProps={{ shrink: true }}
                value={createdFrom}
                onChange={(e) => onChange({ createdFrom: e.target.value })}
            />
            <TextField
                size="small"
                type="date"
                label="To"
                InputLabelProps={{ shrink: true }}
                value={createdTo}
                onChange={(e) => onChange({ createdTo: e.target.value })}
            />
            <Box>
                <Button onClick={onClear} sx={{ textTransform: 'none', color: '#6b7280' }}>
                    Clear
                </Button>
            </Box>
        </Stack>
    );
};

export default CustomersFilters;
